import { ComponentProps } from "react";

import { forwardRef, IconButton } from "@chakra-ui/react";

import { FaPencilAlt } from "react-icons/fa";

import { generateTestId } from "@/util/testIds";

export type EntityEditButtonProps = Omit<
  ComponentProps<typeof IconButton>,
  "aria-label" | "icon"
>;

export const EntityEditButton = forwardRef<EntityEditButtonProps, "button">(
  (props, ref) => (
    <IconButton
      ref={ref}
      aria-label="Edit"
      size="sm"
      icon={<FaPencilAlt />}
      data-testid={generateTestId.button("edit", "entity")}
      {...props}
    />
  )
);
